import React from 'react';
import { Hero } from '../components/sections/Hero';
import { StatsBar } from '../components/sections/StatsBar';
import { VisionSection } from '../components/sections/VisionSection';
import { ServicesCards } from '../components/sections/ServicesCards';
import { WhyChooseUsSection } from '../components/sections/WhyChooseUsSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { CTABanner } from '../components/sections/CTABanner';
import { PartnersSection } from '../components/sections/PartnersSection';
export function HomePage() {
  return <>
      <Hero data-id="element-399" />
      <StatsBar data-id="element-400" />
      <VisionSection data-id="element-401" />
      <ServicesCards data-id="element-402" />
      <WhyChooseUsSection data-id="element-403" />
      <TestimonialsSection data-id="element-404" />
      <HowItWorksSection data-id="element-405" />
      <CTABanner data-id="element-406" />
      <PartnersSection data-id="element-407" />
    </>;
}